import { useState, type ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { colors } from "../lib/tokens";
import { useViewport } from "../hooks/useViewport";

export function Layout({ breadcrumbs, children }: { breadcrumbs: ReactNode; children: ReactNode }) {
  const vp = useViewport();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = vp === "mobile";

  if (isMobile) {
    return (
      <div style={{ minHeight: "100vh", background: colors.paper, position: "relative" }}>
        {drawerOpen && (
          <>
            <div
              onClick={() => setDrawerOpen(false)}
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(14, 17, 22, 0.45)",
                zIndex: 50,
                animation: "klu-fade-in 160ms cubic-bezier(0.32, 0.72, 0, 1)",
              }}
            />
            <div
              style={{
                position: "fixed",
                inset: "0 auto 0 0",
                width: 260,
                zIndex: 60,
                animation: "klu-slide-in-left 200ms cubic-bezier(0.32, 0.72, 0, 1)",
              }}
            >
              <Sidebar onNavigate={() => setDrawerOpen(false)} />
            </div>
          </>
        )}
        <main style={{ background: colors.paper, overflowX: "hidden", minHeight: "100vh" }}>
          <Topbar breadcrumbs={breadcrumbs} onToggleMenu={() => setDrawerOpen(true)} mobile />
          <div style={{ padding: 16 }}>{children}</div>
        </main>
      </div>
    );
  }

  return (
    <div style={{ display: "grid", gridTemplateColumns: "240px 1fr", minHeight: "100vh", background: colors.paper }}>
      <Sidebar />
      <main style={{ background: colors.paper, overflowX: "hidden" }}>
        <Topbar breadcrumbs={breadcrumbs} />
        <div style={{ padding: vp === "tablet" ? 24 : 32, maxWidth: 1280 }}>
          {children}
        </div>
      </main>
    </div>
  );
}
